import { defineStore } from 'pinia';

export const useToastStore = defineStore('toast', {
  state: () => ({
    isVisible: false, // Toast 是否可见
    message: '', // Toast 消息内容
    type: '', // Toast 类型
  }),
});
